<template>
    <div>
        <b-card v-show="mostrarTabela" no-body>
            <b-card-header>
                <span class="h5">Usuários</span>
            </b-card-header>
            <b-card-body>
                <app-tabela
                    idTabela="tblUsuarios"
                    :itens="usuarios"
                    :campos="campos"
                    :itensPorPagina="itensPorPagina"
                >
                    <template slot="botoes">
                        <b-button-group class="float-right">
                            <b-button
                                variant="success"
                                @click="inserirUsuario()"
                                v-if="mostrarBtnInserirUsuario"
                                >Inserir Usuário</b-button
                            >
                        </b-button-group>
                    </template>
                    <template slot="cpf" slot-scope="data">{{
                        data.cpf | toCpfMasked
                    }}</template>
                    <template slot="acoes" slot-scope="data">
                        <span
                            class="text-primary"
                            v-if="
                                $temAcessoView('CTRLACS-USR-02') ||
                                $temAcessoView('FORN-USR-02') ||
                                $temAcessoView('GEST-FORNECEDORES-02')
                            "
                        >
                            <i
                                class="fa fa-info-circle fa-lg icon-button"
                                title="Detalhar"
                                @click.stop="detalharUsuario(data.usuarioId)"
                            ></i>
                        </span>
                    </template>
                </app-tabela>
            </b-card-body>
        </b-card>
        <router-view :gestaoInterna="gestaoInterna"></router-view>
    </div>
</template>

<script>
import UsuariosServicos from './UsuariosServicos'
import UsuariosFornecedorServicos from './UsuariosFornecedorServicos'
import FornecedoresUsuariosServicos from './../../fornecedor/usuarios/UsuariosServicos'
import UsuarioPerfisAcesso from './UsuarioPerfisAcesso'

export default {
    props: {
        gestaoInterna: {
            type: Boolean,
            default: () => false
        }
    },

    data() {
        return {
            usuarios: [],
            fornecedor: false,
            campos: [
                {
                    key: 'nome',
                    label: 'Usuário',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'login',
                    label: 'Login',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'email',
                    label: 'Email',
                    sortable: true,
                    filterable: true
                },
                {
                    key: 'statusDescr',
                    label: 'Status',
                    type: 'status'
                },
                {
                    key: 'dataAtualizacao',
                    label: 'Atualizado em',
                    type: 'datetime'
                },
                {
                    key: 'acoes',
                    label: 'Ações'
                }
            ],
            itensPorPagina: 10
        }
    },
    methods: {
        obterUsuarios() {
            this.$store.dispatch('addRequest')
            let promisse
            if (this.fornecedor) {
                promisse = FornecedoresUsuariosServicos.obterTodos()
            } else if (this.gestaoInterna) {
                promisse = UsuariosFornecedorServicos.obterTodos(
                    this.$route.params.fornecedorId
                )
            } else {
                promisse = UsuariosServicos.obterTodos()
            }

            promisse.then((response) => {
                if (response) {
                    if (response.success) {
                        this.usuarios = response.data
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        inserirUsuario() {
            if (this.fornecedor) {
                this.$router.push({ name: 'Fornecedores_Usuarios_Inserir' })
            } else if (this.gestaoInterna) {
                this.$router.push({ name: 'UsuariosFornecedor_Inserir' })
            } else {
                this.$router.push({ name: 'Usuarios_Inserir' })
            }
        },

        detalharUsuario(id) {
            if (this.fornecedor) {
                this.$router.push({
                    name: 'Fornecedores_Usuarios_Detalhar',
                    params: {
                        usuarioId: id
                    }
                })
            } else if (this.gestaoInterna) {
                this.$router.push({
                    name: 'UsuariosFornecedor_Detalhar',
                    params: {
                        usuarioId: id
                    }
                })
            } else {
                this.$router.push({
                    name: 'Usuarios_Detalhar',
                    params: {
                        usuarioId: id
                    }
                })
            }
        },

        perfisAcessoUsuario(usuarioId) {
            this.$router.push({
                name: `${this.$route.name}_PerfisAcesso`,
                params: {
                    usuarioId: usuarioId
                }
            })
        },

        confirmaDesativacaoUsuario(usuarioId) {
            let usuarioTemp = this.usuarios.filter((item) => {
                return item.usuarioId === usuarioId
            })[0]
            this.$swal({
                title: 'Desativação de Usuário',
                html: `Confirma a desativação do usuário <b>${usuarioTemp.nome}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.ativarDesativarUsuario(usuarioId)
                }
            })
        },

        confirmaAtivacaoUsuario(usuarioId) {
            let usuarioTemp = this.usuarios.filter((item) => {
                return item.usuarioId === usuarioId
            })[0]
            this.$swal({
                title: 'Ativação de Usuário',
                html: `Confirma a ativação do usuário <b>${usuarioTemp.nome}</b>?`,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.ativarDesativarUsuario(usuarioId)
                }
            })
        },

        ativarDesativarUsuario(usuarioId) {
            this.$store.dispatch('addRequest')
            UsuariosServicos.ativarDesativarUsuario({
                usuarioId: usuarioId,
                instituicaoId: this.$store.getters.instituicaoTemp.instituicaoId
            }).then((response) => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Registro atualizado com sucesso!',
                            'OK',
                            this.success
                        )
                        this.obterUsuarios()
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    created() {
        if (this.$store.getters.fornecedor.fornecedorId) {
            this.fornecedor = true
        }
        this.obterUsuarios()
    },

    computed: {
        mostrarTabela() {
            return (
                this.$route.name === 'Usuarios' ||
                this.$route.name === 'Fornecedores_Usuarios' ||
                this.$route.name === 'UsuariosFornecedor'
            )
        },

        mostrarBtnInserirUsuario() {
            return (
                this.$temAcessoView('CTRLACS-USR-01') ||
                this.$temAcessoView('FORN-USR-01') ||
                this.$temAcessoView('GEST-FORNECEDORES-02')
            )
        }
    },

    watch: {
        $route(to) {
            if (
                to.name === 'Usuarios' ||
                to.name === 'Fornecedores_Usuarios' ||
                to.name === 'UsuariosFornecedor'
            ) {
                if (this.$store.getters.recarregar) {
                    this.obterUsuarios()
                    this.$store.dispatch('setRecarregar', false)
                }
            }
        }
    },

    components: {
        UsuarioPerfisAcesso: UsuarioPerfisAcesso
    }
}
</script>
